import { render, staticRenderFns } from "./QSupportTicketsDataTable.vue?vue&type=template&id=7a917e05&scoped=true&"
import script from "./QSupportTicketsDataTable.vue?vue&type=script&lang=js&"
export * from "./QSupportTicketsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QSupportTicketsDataTable.vue?vue&type=style&index=0&id=7a917e05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a917e05",
  null
  
)

export default component.exports